import { TableSkeleton } from '@/components/skeletons'
import { Card, CardContent, Skeleton } from '@/components/ui'

const TileSkeleton = () => (
  <Card>
    <CardContent className="flex flex-col gap-3 p-5">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="size-8 rounded-lg" />
      </div>
      <Skeleton className="h-8 w-24" />
      <Skeleton className="h-3 w-28" />
    </CardContent>
  </Card>
)

const TopCaseRowSkeleton = () => (
  <div className="space-y-1.5">
    <div className="flex items-center justify-between gap-3">
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-4 w-10" />
    </div>
    <Skeleton className="h-1.5 w-full rounded-full" />
  </div>
)

// Mirrors ProjectUsageDashboard so the page keeps its shape while projects load, instead of a blank
// screen that snaps into place.
export const DashboardSkeleton = () => (
  <div className="space-y-6">
    <div className="space-y-1.5">
      <Skeleton className="h-9 w-64" />
      <Skeleton className="h-6 w-96" />
    </div>

    <div className="flex justify-end gap-2">
      <Skeleton className="h-8 w-36" />
      <Skeleton className="h-8 w-24" />
    </div>

    <div className="space-y-2.5">
      <Skeleton className="h-4 w-56" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
      </div>
    </div>

    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <Card className="lg:col-span-2">
        <CardContent className="space-y-4 p-6">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-[300px] w-full" />
        </CardContent>
      </Card>
      <Card>
        <CardContent className="space-y-4 p-6">
          <Skeleton className="h-6 w-28" />
          <div className="space-y-3.5">
            <TopCaseRowSkeleton />
            <TopCaseRowSkeleton />
            <TopCaseRowSkeleton />
            <TopCaseRowSkeleton />
            <TopCaseRowSkeleton />
            <TopCaseRowSkeleton />
          </div>
        </CardContent>
      </Card>
    </div>

    <div className="overflow-hidden rounded-lg border">
      <TableSkeleton rows={8} />
    </div>
  </div>
)
